import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box, { type BoxProps } from "@mui/material/Box";
import * as React from "react";

interface CustomTabsProps {
  tabValue: number;
  uniqueKey: string;
  tabs: {
    index: number;
    label: string;
  }[];
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const CustomTabs = ({
  tabValue,
  tabs,
  uniqueKey,
  handleChange,
}: CustomTabsProps) => {
  function a11yProps(index: number, uniqueKey: string) {
    const uniqueId = `${uniqueKey}-tabpanel-${index}`;
    return {
      id: uniqueId,
      "aria-controls": uniqueId,
    };
  }

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="tabs"
          variant="fullWidth"
        >
          {tabs.map(tab => {
            return (
              <Tab
                label={tab.label}
                key={"main-tab" + tab.index}
                value={tab.index}
                data-testid={`${uniqueKey}-panel-tab`}
                {...a11yProps(tab.index, uniqueKey)}
              />
            );
          })}
        </Tabs>
      </Box>
    </>
  );
};

export default CustomTabs;

interface TabPanelProps extends Omit<BoxProps, "children"> {
  index: number;
  value: number;
  uniqueKey: string;
  children: React.ReactNode;
  renderOnlySelectedPanel?: boolean;
}

export function CustomTabPanel(props: TabPanelProps) {
  const {
    children,
    value,
    index,
    uniqueKey,
    renderOnlySelectedPanel = false,
    sx,
    ...other
  } = props;

  const uniqueId = `${uniqueKey}-tabpanel-${index}`;

  let render: React.ReactNode;

  if (renderOnlySelectedPanel) {
    if (value === index) {
      render = children;
    }
  } else {
    render = children;
  }
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={uniqueId}
      aria-labelledby={uniqueId}
      {...other}
      sx={[
        {
          height: "100%",
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {render}
    </Box>
  );
}
